import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import gql from 'graphql-tag';
import {Apollo} from 'apollo-angular';
import {GetContentItem, GetContentItem_contentItem} from './__generated__/GetContentItem';
import {ImageTypeEnum} from '../../../shared/graphql/globalTypes';
import {UntypedFormControl} from '@angular/forms';
import {filter, Subscription} from 'rxjs';
import {
  getSpecificTimeSelection,
  SpecificTimeSelection,
} from '../../../shared/utils/date-sort.utils';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ContentDisplayComponent} from '../../../shared/modals/content-display/content-display.component';
import {ErrorService} from '../../../shared/services/error.service';
import {ToastrService} from 'ngx-toastr';
import {NavigationService} from 'src/app/shared/services/navigation.service';

const contentItemGetQuery = gql`
  query GetContentItem($id: ID!) {
    contentItem(id: $id ) {
      id
      created
      templateItem {
        id
        title
        template {
          id
          title
          items {
            id
          }
        }
        lookupId
      }
      title
      type
      url
      downloadUrl
      views {
        totalCount
      }
    }
  }
`;

@Component({
  selector: 'app-video-view',
  templateUrl: './content-view.component.html',
  styleUrls: ['./content-view.component.scss'],
  standalone: false,
})
export class ContentViewComponent implements OnInit, OnDestroy {
  contentItem: GetContentItem_contentItem | null = null;
  ImageTypeEnum = ImageTypeEnum;
  search = new UntypedFormControl(null);
  pageCount = 1;
  pages: number[] = [];
  totalCount: number | null = null;
  bsModalRef: BsModalRef | null = null;
  loading = true;
  specificTimeSelections: SpecificTimeSelection[] = [];
  private subscriptions: Subscription[] = [];
  shareUrl = '';

  constructor(
    private router: Router,
    private apollo: Apollo,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private navigation: NavigationService,
    private errService: ErrorService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.specificTimeSelections = getSpecificTimeSelection();
    // set date selection on 'this year'

    this.subscriptions.push(
      this.apollo
        .watchQuery<GetContentItem>({
          query: contentItemGetQuery,
          variables: {
            id: this.route.snapshot.params['id'],
          },
        })
        .valueChanges
        .pipe(
          filter(output => !output.loading)
        )
        .subscribe(output => {
          const contentItem = output.data?.contentItem ?? null;
          if (contentItem !== null) {
            this.contentItem = contentItem;
            this.shareUrl =
              location.origin +
              this.router.createUrlTree([
                'view-content',
                contentItem.templateItem.lookupId,
                contentItem.type?.toLowerCase(),
                contentItem.title,
              ]);
          } else {
            this.toastr.warning($localize`No content found`);
          }
        }),
    );
  }

  openModal(url: string | null, type: ImageTypeEnum | null): void {
    this.bsModalRef = this.modalService.show(ContentDisplayComponent, {
      class: 'content-display-modal',
    });
    this.bsModalRef.content.url = url;
    this.bsModalRef.content.type = type;
  }

  copyUrl(): void {
    this.toastr.success($localize`Copied`);
  }

  backToContent(): void {
    const {navigationId} = window.history.state;
    if (navigationId > 1) {
      window.history.back();
    } else {
      this.router.navigateByUrl('/content');
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }
}
